var jade = require("/var/lib/jenkins-code/academia-app/node_modules/.pnpm/jade@1.11.0/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<p class=\"u-p2x\">Notifications are temporarily unavailable while we do some maintenance.</p>");;return buf.join("");
}